import React from "react";
import NotFound from "./notFound";
import { useSelector } from "react-redux";
import CareersRegister from "../registration/index";
function Page(props) {
    const { url404Data, url404DataError } = useSelector((state) => state.commonData);
  
    if (url404Data?.status_code === 301) {
      window.location.href = url404Data?.redirect;
    } else if (url404Data?.status_code === 410) {
      return <div>410 Gone</div>;
    } else if (url404Data?.status_code === 404 || url404DataError) {
      return <NotFound />;
    }
    return <CareersRegister />;
  }

export default Page;